import {
    FETCH_CLIENTSDB_BEGIN,
    FETCH_CLIENTSDB_SUCCESS,
    FETCH_CLIENTSDB_ERROR,
    FETCH_CLIENTSDB_RESET,
    POST_CLIENTSDB_BEGIN,
    POST_CLIENTSDB_ERROR,
    POST_CLIENTSDB_RESET,
    POST_CLIENTSDB_SUCCESS,
    FETCH_CLIENTS_TRAVAUX_BEGIN,
    FETCH_CLIENTS_TRAVAUX_ERROR,
    FETCH_CLIENTS_TRAVAUX_RESET,
    FETCH_CLIENTS_TRAVAUX_SUCCESS,
    DELETE_CV_FILE_BEGIN,
    DELETE_CV_FILE_ERROR,
    DELETE_CV_FILE_RESET,
    DELETE_CV_FILE_SUCCESS,
    DELETE_CV_BEGIN,
    DELETE_CV_ERROR,
    DELETE_CV_RESET,
    DELETE_CV_SUCCESS
} from "../actions/clientsActions"

const initialState = {
    clients: [],
    page: 1,
    next_page: null,
    previous_page: null,
    num_page: null,
    travaux: [],
    fetchClients: {
        loading: false,
        error: false
    },
    fetchTravaux: {
        loading: false,
        error: false
    },
    postClient: {
        saving: false,
        saved: false,
        error: false
    },
    deleteCVFile: {
        deleting: false,
        deleted: false,
        error: false
    },
    deleteCV: {
        deleting: false,
        deleted: false,
        error: false
    }
}

export default function clientsReducer(state = initialState, action) {
    let nextState
    switch (action.type) {
        case FETCH_CLIENTSDB_BEGIN:
            return {
                ...state,
                fetchClients: {
                    loading: true,
                    error: false
                }
            }

        case FETCH_CLIENTSDB_SUCCESS:
            nextState = {
                ...state,
                clients: action.payload.data.clients,
                page: action.payload.data.current_page,
                next_page: action.payload.data.next_page,
                previous_page: action.payload.data.previous_page,
                num_page: action.payload.data.num_pages,
                fetchClients: {
                    loading: false,
                    error: false
                }
            }
            return nextState

        case FETCH_CLIENTSDB_ERROR:
            return {
                ...state,
                fetchClients: {
                    loading: false,
                    error: action.payload.error
                }
            }
        case FETCH_CLIENTSDB_RESET:
            return {
                ...state,
                fetchClients: {
                    loading: false,
                    error: false
                }
            }
        case POST_CLIENTSDB_BEGIN:
            return {
                ...state,
                postClient: {
                    saving: true,
                    saved: false,
                    error: false
                }
            }

        case POST_CLIENTSDB_SUCCESS:
            return {
                ...state,
                clients: action.payload.data.data,
                page: action.payload.data.page,
                next_page: action.payload.data.next_page,
                previous_page: action.payload.data.previous_page,
                num_page: action.payload.data.num_page,
                postClient: {
                    saving: false,
                    saved: true,
                    error: false
                }
            }
        case POST_CLIENTSDB_ERROR:
            return {
                ...state,
                postClient: {
                    saving: false,
                    saved: false,
                    error: action.payload.error
                }
            }
        case POST_CLIENTSDB_RESET:
            return {
                ...state,
                postClient: {
                    saving: false,
                    saved: false,
                    error: false
                }
            }
        case FETCH_CLIENTS_TRAVAUX_BEGIN:
            return {
                ...state,
                fetchTravaux: {
                    loading: true,
                    error: false
                }
            }

        case FETCH_CLIENTS_TRAVAUX_SUCCESS:
            nextState = {
                ...state,
                travaux: action.payload.travaux,
                fetchTravaux: {
                    loading: false,
                    error: false
                }
            }
            return nextState

        case FETCH_CLIENTS_TRAVAUX_ERROR:
            return {
                ...state,
                fetchTravaux: {
                    loading: false,
                    error: action.payload.error
                }
            }
        case FETCH_CLIENTS_TRAVAUX_RESET:
            return {
                ...state,
                travaux: [],
                fetchTravaux: {
                    loading: false,
                    error: false
                }
            }
        case DELETE_CV_FILE_BEGIN:
            return {
                ...state,
                deleteCVFile: {
                    deleting: true,
                    deleted: false,
                    error: false
                }
            }

        case DELETE_CV_FILE_SUCCESS:
            return {
                ...state,
                deleteCVFile: {
                    deleting: false,
                    deleted: true,
                    error: false
                }
            }
        case DELETE_CV_FILE_ERROR:
            return {
                ...state,
                deleteCVFile: {
                    deleting: false,
                    deleted: false,
                    error: action.payload.error
                }
            }
        case DELETE_CV_FILE_RESET:
            return {
                ...state,
                deleteCVFile: {
                    deleting: false,
                    deleted: false,
                    error: false
                }
            }
        case DELETE_CV_BEGIN:
            return {
                ...state,
                deleteCV: {
                    deleting: true,
                    deleted: false,
                    error: false
                }
            }

        case DELETE_CV_SUCCESS:
            return {
                ...state,
                deleteCV: {
                    deleting: false,
                    deleted: true,
                    error: false
                }
            }
        case DELETE_CV_ERROR:
            return {
                ...state,
                deleteCV: {
                    deleting: false,
                    deleted: false,
                    error: action.payload.error
                }
            }
        case DELETE_CV_RESET:
            return {
                ...state,
                deleteCV: {
                    deleting: false,
                    deleted: false,
                    error: false
                }
            }
        default:
            return state
    }
}
